import type { Variant } from '@storefront/lib-global/codegen/types';
import { isOutOfStock } from './isOutOfStock';

export const isValueDisplayed = (
  value: string,
  selected: string,
  variants: Variant[],
  isSubdomainOutlet: boolean,
): boolean => {
  const crossed = isOutOfStock(value, selected, variants);

  return !crossed || (crossed && !isSubdomainOutlet);
};
